var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop, Emit, Model } from "vue-property-decorator";
var NumberRange = /** @class */ (function (_super) {
    __extends(NumberRange, _super);
    function NumberRange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.vMin = "";
        _this.vMax = "";
        return _this;
    }
    NumberRange.prototype.validate = function (rule, value, callback) {
        if (this.numberRange.min > this.numberRange.max) {
            callback(new Error("输入数字范围有误"));
        }
    };
    NumberRange.prototype.resetField = function (min, max) {
        if (min === void 0) { min = ""; }
        if (max === void 0) { max = ""; }
        this.minValue = min;
        this.maxValue = max;
    };
    NumberRange.prototype.onValueChange = function (value) {
        if (!value)
            return;
        this.vMin = value.min;
        this.vMax = value.max;
    };
    NumberRange.prototype.updateNumberRange = function (value) {
        return;
    };
    Object.defineProperty(NumberRange.prototype, "minValue", {
        get: function () {
            return this.vMin;
        },
        set: function (value) {
            this.vMin = value;
            this.updateNumberRange({
                min: this.vMin,
                max: this.vMax
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumberRange.prototype, "maxValue", {
        get: function () {
            return this.vMax;
        },
        set: function (value) {
            this.vMax = value;
            this.updateNumberRange({
                min: this.vMin,
                max: this.vMax
            });
        },
        enumerable: false,
        configurable: true
    });
    NumberRange.prototype.parseInt = function (value) {
        if (this.isInteger) {
            return Math.round(Number.parseFloat(value));
        }
        return value;
    };
    __decorate([
        Prop({ default: "最小值" })
    ], NumberRange.prototype, "minPlaceholder", void 0);
    __decorate([
        Prop({ default: "最大值" })
    ], NumberRange.prototype, "maxPlaceholder", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], NumberRange.prototype, "isInteger", void 0);
    __decorate([
        Model("numberRangeChange")
    ], NumberRange.prototype, "numberRange", void 0);
    __decorate([
        Watch("numberRange", { deep: true })
    ], NumberRange.prototype, "onValueChange", null);
    __decorate([
        Emit("numberRangeChange")
    ], NumberRange.prototype, "updateNumberRange", null);
    NumberRange = __decorate([
        Component({
            components: {}
        })
    ], NumberRange);
    return NumberRange;
}(Vue));
export default NumberRange;
